const determineData = (action) => {
  if (!action) return action;

  // the FE UI actions have .data
  if (action.data) return action.data;

  // the failure calls to BE have .errorMessage
  if (action.errorMessage) return action.errorMessage;

  // the success calls to BE have .response
  // but, they carry their .params as well
  if (action.response) return { response: action.response, params: action.params };

  // the odd actions have data flat on the object, right next to the type
  // so, as it is an unrecognized shape, just return it as data
  return action;
};

// noinspection JSUnusedGlobalSymbols
export default determineData;
